"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPCSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const types_1 = require("../../../Shared/types");
const NPC_1 = require("../../Assemblages/NPC");
const GameData_1 = require("../../../Shared/GameData");
const assert = require("assert");
const DialogueData_1 = require("../../../Shared/DialogueData");
class NPCSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.NPC);
        this.isWaitingForClientPlayer = true;
        this.startedTutorial = false;
        this.fadedIn = false;
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.GAME_STATE_INITIALIZED:
                this.handleInitializedGameState(message.data);
                break;
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.handleInitializedClientPlayer();
                break;
        }
    }
    addNomTook(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const npc = new NPC_1.NPC(types_1.NPC_TYPES.NomTook);
            this.nomTook = npc;
            this.nomTookSkeleton = yield this.globals.gottimation.createSkeleton('nomtook', { direction: 'south' });
            yield this.nomTookSkeleton.setSkins([
                { atlasName: 'nomtook', skinName: 'default.png' }
            ]);
            this.initializeEntity(npc, { speed: types_1.GameValues.PlayerSpeed, x: data.position.x, y: data.position.y, skeleton: this.nomTookSkeleton });
            this.nomTookGameObject = this.globals.tileWorld.addGameObject({
                sprite: this.nomTookSkeleton,
                position: { x: data.position.x, y: data.position.y },
                layer: 1,
                colliders: [{ layer: 1, shapeData: { x: 10, y: 23, r: 10 }, dynamic: true, tags: [Constants_1.COLLIDER_TAGS.npc, Constants_1.COLLIDER_TAGS.prevent_hole] }],
            });
            npc.gameObject = this.nomTookGameObject;
            npc.gameObject.entity = npc;
            this.nomTookGameObject.sprite.x = data.position.x;
            this.nomTookGameObject.sprite.y = data.position.y;
            return npc;
        });
    }
    handleInitializedClientPlayer() {
        //console.error('clinet pos here was', { ...this.globals.clientPlayer.getPosition() });
        this.isWaitingForClientPlayer = false;
        this.doStartGameIfReadyAndNeeded();
    }
    handleInitializedGameState(state) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addNomTook(state.npcData.nomTook);
            this.doStartGameIfReadyAndNeeded();
        });
    }
    doStartGameIfReadyAndNeeded() {
        if (!this.$api.needsTutorial())
            return;
        if (!this.isWaitingForClientPlayer && this.nomTookGameObject && this.fadedIn && !this.startedTutorial) {
            this.startedTutorial = true;
            const nomMovement = this.nomTook.getComponent(Constants_1.SYSTEMS.NPC_MOVEMENT);
            const playerMovement = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.NPC_MOVEMENT);
            nomMovement.moveTo(GameData_1.NOM_TOOK_WALK_TO_YOU.x, GameData_1.NOM_TOOK_WALK_TO_YOU.y);
            this.nomTook.once('reached-spot', () => __awaiter(this, void 0, void 0, function* () {
                const d = DialogueData_1.startGameDialogue(this.globals.clientPlayer.gameState.playerName);
                yield this.$api.doDialogue(d, 'Nom Took');
                nomMovement.moveToQueue([...GameData_1.WALK_TO_HOUSE_PATHS.nomTook]);
                playerMovement.moveToQueue([...GameData_1.WALK_TO_HOUSE_PATHS.player]);
                const lastPosition = GameData_1.WALK_TO_HOUSE_PATHS.player[GameData_1.WALK_TO_HOUSE_PATHS.player.length - 1];
                const playerMovementListener = ({ x, y, direction }) => {
                    if (x === lastPosition.x && y === lastPosition.y && direction === lastPosition.direction) {
                        this.globals.clientPlayer.emit('reached-house', true);
                    }
                };
                this.globals.clientPlayer.on('reached-spot', playerMovementListener);
                this.globals.clientPlayer.once('reached-house', () => __awaiter(this, void 0, void 0, function* () {
                    this.globals.clientPlayer.off('reached-spot', playerMovementListener);
                    yield this.$api.doDialogue(DialogueData_1.houseHagglingDialogue, 'Nom Took');
                    this.$api.addItem('shovel', 1);
                    //todo: show shovel
                    yield this.$api.doDialogue(DialogueData_1.explainShovelDialogue, 'Nom Took');
                    const nextNext = () => {
                        const items2 = this.globals.clientPlayer.gameState.inventory;
                        const anyPedals = !!(items2.find(i => i.name.includes('pedals')));
                        const anyBees = !!(items2.find(i => i.name.includes('bee')));
                        let sellBeeOption;
                        let sellPedalsOption;
                        let totalPedalHoney = 0;
                        let totalBeeHoney = 0;
                        let totalBeeAmount = 0;
                        if (anyPedals) {
                            const pedalLookup2 = {};
                            for (let i = 0; i < items2.length; i++) {
                                if (items2[i].name.includes('pedals')) {
                                    pedalLookup2[items2[i].name] = items2[i].quantity;
                                    totalPedalHoney += GameData_1.GlobalGameData.items[items2[i].name].shop.sellPrice * items2[i].quantity;
                                }
                            }
                            sellPedalsOption = () => {
                                for (let key in pedalLookup2) {
                                    this.$api.removeItem(key, pedalLookup2[key]);
                                }
                                this.$api.addHoney(totalPedalHoney);
                            };
                        }
                        if (anyBees) {
                            for (let i = 0; i < items2.length; i++) {
                                if (items2[i].name === 'bee') {
                                    totalBeeAmount = items2[i].quantity;
                                    totalBeeHoney += GameData_1.GlobalGameData.items[items2[i].name].shop.sellPrice * items2[i].quantity;
                                }
                            }
                            sellBeeOption = () => {
                                this.$api.removeItem('bee', totalBeeAmount);
                                this.$api.addHoney(totalBeeHoney);
                            };
                        }
                        //console.error('next next idalopgyue became', finishedTasksMonTookDialogueFactory(this.$api.openShop, sellPedalsOption, sellBeeOption))
                        return DialogueData_1.finishedTasksMonTookDialogueFactory(this.$api.openShop, sellPedalsOption, sellBeeOption);
                    };
                    const getNextDialogue = () => {
                        const items = this.globals.clientPlayer.gameState.inventory;
                        const hadPedals = !!(items.find(i => i.name.includes('pedals')));
                        let sellFlowerCallback;
                        if (hadPedals) {
                            const pedalLookup = {};
                            let totalHoney = 0;
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].name.includes('pedals')) {
                                    pedalLookup[items[i].name] = items[i].quantity;
                                    totalHoney += GameData_1.GlobalGameData.items[items[i].name].shop.sellPrice * items[i].quantity;
                                }
                            }
                            sellFlowerCallback = () => __awaiter(this, void 0, void 0, function* () {
                                for (let key in pedalLookup) {
                                    this.$api.removeItem(key, pedalLookup[key]);
                                }
                                this.$api.addHoney(totalHoney);
                                yield this.$api.doDialogue(DialogueData_1.firstTimeHandingInFlowerDialogue);
                                this.$api.addItem('net', 1);
                                this.nomTook.onNextDialogue(nextNext, () => { });
                                this.dispatchLocalInstant({
                                    to: [Constants_1.SYSTEMS.GAME_STATE],
                                    type: Constants_1.MESSAGES.FINISH_NPC_TASK,
                                    data: 'nomTook'
                                });
                                assert.strictEqual(this.globals.clientPlayer.gameState.npcData.nomTook.task, 2);
                            });
                        }
                        return DialogueData_1.talkAfterTutorialDialogue(hadPedals, sellFlowerCallback);
                    };
                    this.nomTook.onNextDialogue(getNextDialogue, null);
                    assert.strictEqual(this.globals.clientPlayer.gameState.npcData.nomTook.task, 0);
                    assert(this.globals.clientPlayer.hasComponent(Constants_1.SYSTEMS.NPC_MOVEMENT));
                    assert(this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT).disabled);
                    this.dispatchLocalInstant({
                        to: [Constants_1.SYSTEMS.GAME_STATE],
                        type: Constants_1.MESSAGES.FINISH_NPC_TASK,
                        data: 'nomTook'
                    });
                    assert.strictEqual(this.globals.clientPlayer.gameState.npcData.nomTook.task, 1);
                }));
            }));
        }
    }
    onClear() {
    }
    onInit() {
    }
    onPeerMessage(peerId, message) {
    }
    getNomTook() {
        return this.nomTook;
    }
    onStart() {
        this.addApi(this.getNomTook);
        if (this.$api.needsTutorial()) {
            gotti_1.default.once('faded-in-halfway', () => {
                this.fadedIn = true;
                this.doStartGameIfReadyAndNeeded();
            });
        }
        this.spawnBear();
    }
    spawnBear() {
        const bear = this.globals.tileWorld.addGameObject({
            texture: this.globals.gameTextures.bear,
            position: Object.assign({}, this.globals.bearSpawn),
            layer: 1,
            colliders: [{ layer: 1, shapeData: { x: 10, y: 23, r: 10 }, dynamic: true, tags: [Constants_1.COLLIDER_TAGS.npc, Constants_1.COLLIDER_TAGS.prevent_hole] }],
        });
        bear.updatePosition(this.globals.bearSpawn.x, this.globals.bearSpawn.y);
        const npc = new NPC_1.NPC(types_1.NPC_TYPES.Bear);
        this.initializeEntity(npc, { speed: types_1.GameValues.PlayerSpeed, x: this.globals.bearSpawn.x, y: this.globals.bearSpawn.y, });
        npc.onNextDialogue(DialogueData_1.bearDialogueData, () => { });
    }
    onEntityAddedComponent(entity, component) {
    }
    onServerMessage(message) {
    }
    update(delta) {
    }
}
exports.NPCSystem = NPCSystem;
//# sourceMappingURL=module.js.map